import React from 'react'
import { Form, Input, Select, Spin } from 'antd'
import { REGION_SOURCES } from '../CoverageCommon'
import container from './container'

const HotelRegionForm = props => {
    const { $form, $props, $loading, $fieldProps } = props

    return (
        <Spin spinning={$loading}>
            <Form {...$props} colon={false} layout={'vertical'} wrapperCol={{ flex: 1 }}>
                {$form.Item({ name: 'hotel_id' })}
                <Form.Item
                    name={'region_ids'}
                    label={'Region ID'}
                    extra={'Must exist in lst_region. Several ids can be separated by commas or spaces.'}
                    {...$fieldProps.region_ids}>
                    <Input placeholder={'3023'} />
                </Form.Item>
                <Form.Item name={'supplier_code'} label={'Source'} {...$fieldProps.supplier_code}>
                    <Select>
                        {REGION_SOURCES.map(source => (
                            <Select.Option value={source} key={source}>
                                {source}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Spin>
    )
}

export default container(HotelRegionForm)
